export enum PostedStatus {
    DRAFT = 'draft',
    POSTED = 'posted',
    PENDING = 'pending',
    RETRY = 'retry',
    REJECTED = 'rejected',
}

export enum ReplyVisibility {
    PUBLIC = 'public',
    PRIVATE = 'private',
}

export enum RejectedReason {
    BOOKING_REPLY_ALREADY_EXISTS = 'booking_reply_already_exists',
    INAPPROPRIATE = 'inappropriate',
    UNKNOWN = 'unknown',
}

export enum SemanticAnalysisProviderKey {
    OPENAI = 'openai',
}

export enum ReviewAnalysisSentiment {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    NEUTRAL = 'neutral',
}

export enum ReviewAnalysisTag {
    ATMOSPHERE = 'atmosphere',
    EXPEDITIOUSNESS = 'expeditiousness',
    FOOD = 'food',
    HYGIENE = 'hygiene',
    OVERALL_EXPERIENCE = 'overall_experience',
    PRICE = 'price',
    SERVICE = 'service',
}

export enum ReviewAnalysisSubCategory {
    MENU_ITEMS = 'menu_items',
    STAFF_MEMBERS = 'staff_members',
}

export enum ReviewAnalysisStatus {
    DONE = 'done',
    PENDING = 'pending',
    FAILED = 'failed',
    REVIEW_TOO_OLD = 'review_too_old',
    UNSUPPORTED_PLATFORM = 'unsupported_platform',
    NO_RESULTS = 'no_results',
}

export enum PlatformPresenceStatus {
    NOT_FOUND = 'not_found', // means that the reviews was not found/deleted on the platform
    FOUND = 'found',
}

export enum ReviewReplyState {
    NONE = 'none',
    UNANSWERED = 'unanswered',
    PENDING = 'pending',
    POSTED = 'posted',
    POSTED_WITH_PENDING = 'posted_with_pending',
}

/**
 * Precomputed, index-backed review filter fields. Shared contract between the backend read path (`buildQueryV2`,
 * review schema) and the Atlas trigger that is the single producer of these values (see `services/atlas/app-services`).
 */
export interface ReviewFilterFields {
    replyState: ReviewReplyState;
    hasRejectedComment: boolean;
    hasSuggestion: boolean;
    hasDisplayableContent: boolean;
    canReply: boolean;
    answerableUntil: Date | null;
}

/**
 * Used for chart in frontend
 */
export enum ReviewAnalysisChartDataTag {
    ATMOSPHERE = ReviewAnalysisTag.ATMOSPHERE,
    EXPEDITIOUSNESS = ReviewAnalysisTag.EXPEDITIOUSNESS,
    FOOD = ReviewAnalysisTag.FOOD,
    HYGIENE = ReviewAnalysisTag.HYGIENE,
    PRICE = ReviewAnalysisTag.PRICE,
    SERVICE = ReviewAnalysisTag.SERVICE,
    TOTAL = 'total',
}

export enum ReviewAnalysisChartDataSentiment {
    POSITIVE = ReviewAnalysisSentiment.POSITIVE,
    NEGATIVE = ReviewAnalysisSentiment.NEGATIVE,
    TOTAL = 'total',
}

export enum ReviewCannotReplyExplanation {
    IS_TOO_OLD = 'is_too_old',
    HAS_NO_TEXT = 'has_no_text',
    PLATFORM_DOESNT_SUPPORT_REPLY = 'platform_doesnt_support_reply',
    NO_EMAIL = 'no_email',
    NO_REVIEWER_NAME = 'no_reviewer_name',
}
